// extracted by mini-css-extract-plugin
module.exports = {"title":"_6f25b66c20--title--H_vFL"};